import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-batch-transactions',
  templateUrl: './batch-transactions.component.html',
  styleUrls: ['./batch-transactions.component.scss']
})
export class BatchTransactionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
